import { DEFAULT_MINIMUM_PAYOUT_CENTS } from "@songtradr-one/shared-common";

/** en-US currency format; sub-cent amounts keep extra precision, `trimZeroCents` drops ".00" on whole amounts. */
export const formatAmount = (
  amount: number,
  currency?: string | null,
  { trimZeroCents = false } = {},
): string => {
  const code = currency || "USD";
  const fractionDigits = trimZeroCents && Number.isInteger(amount) ? 0 : 2;
  const isSubCent = amount !== 0 && Math.abs(amount) < 0.005;

  try {
    return amount.toLocaleString("en-US", {
      style: "currency",
      currency: code,
      minimumFractionDigits: fractionDigits,
      ...(isSubCent && { maximumFractionDigits: 5 }),
    });
  } catch (error) {
    if (!(error instanceof RangeError)) throw error;
    return `${amount.toFixed(fractionDigits)} ${code}`;
  }
};

/** Dividing by 100 is exact enough to display. */
export const formatCents = (cents: number, currency?: string | null): string =>
  formatAmount(cents / 100, currency);

/** Capped so its cents fit a GraphQL Int. */
export const DOLLAR_AMOUNT_PATTERN = /^\d{1,7}(\.\d{1,2})?$/;

export const dollarsToCents = (dollars: string): number =>
  Math.round(Number(dollars) * 100);

export const centsToDollarsInput = (cents: number): string =>
  (cents / 100).toFixed(2);

/** An empty value passes; add `required` where the field needs a value. */
export const payoutMinimumRules = (messages: {
  format: string;
  min: string;
}) => ({
  pattern: { value: DOLLAR_AMOUNT_PATTERN, message: messages.format },
  // Runs only once the pattern passed.
  validate: (value: unknown) =>
    !value ||
    dollarsToCents(String(value)) >= DEFAULT_MINIMUM_PAYOUT_CENTS ||
    messages.min,
});
